import styled from "@emotion/styled";

export const ListWrap = styled.div`
  a {
    text-decoration: none;
    color: #ccd6f6;
    margin-left: 1.5em;
    font-family: monospace;
    font-size: 14px;
    margin-top: 10%;
    &:hover {
      color: #64ffda;
    }
    .kanji {
      color: #64ffda;
    }
  }
  .btn-menu {
    margin-left: 1.5em;
    margin-top: 10%;
    .menuTextbtn {
      font-size: 14px;
      text-decoration: none;
      font-family: monospace;
      color: #64ffda;
    }
  }
`;
